module.exports = __webpack_public_path__ + "static/media/sphere.df724f97.svg";